import React from 'react';

export const CheckWhiteIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.351 3.92359L6.07885 11.1936C5.94662 11.3258 5.8144 11.3918 5.61607 11.3918C5.41774 11.3918 5.28551 11.3258 5.15329 11.1936L1.84775 7.88904C1.5833 7.62467 1.5833 7.22813 1.84775 6.96377C2.11219 6.6994 2.50886 6.6994 2.7733 6.96377L5.61607 9.80567L12.4255 2.99832C12.6899 2.73396 13.0866 2.73396 13.351 2.99832C13.6155 3.26268 13.6155 3.65923 13.351 3.92359Z"
        fill="white"
      />
    </svg>
  );
};
